import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import config from 'config/config';
import checkOrSetSlash from 'utils/checkOrSetSlash';
import { prepareFCHeader } from 'utils/request';

const baseUrl = `${checkOrSetSlash(config.apiHostGateway, 'apiHostGateway')}api/`;

export const userRolesApi = createApi({
  reducerPath: 'userRolesApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: prepareFCHeader(),
  }),
  tagTypes: ['ProjectUserRolesList'],
  endpoints: builder => ({
    fetchProjectUserRoles: builder.query({
      query: ({ projectId }) => ({
        url: `v2.5/projects/${projectId}/project-roles`,
        method: 'GET',
      }),
      providesTags: ['ProjectUserRolesList'],
    }),
    fetchOrganizationUserRoles: builder.query({
      query: () => ({
        url: `v1.0/project-roles`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useFetchProjectUserRolesQuery, useFetchOrganizationUserRolesQuery } = userRolesApi;
